/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';


import UIImage from './ui/UIImage';

// const PageTypeCheckbox = withStyles({
//   root: {
//     color: 'black',
//     padding: 0,
//     marginRight: '0.5rem',
//   },
//   checked: {},
// })(props => <Checkbox color="default" {...props} />);

const ImageModule = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialStateMediaDesc = {
    type: 'MediaDescription',
    imageUrl: {
      en: '',
    },
    description: {
      en: '',
    },
    layout: 'none',
    isPublic: true,
    isDisplayDescriptionOn: false,
    imageUrlMobile: {
      en: '',
    },
    link: null,
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialStateMediaDesc);
  const [showDescription, setShowDescription] = useState(false);
  const [layout, setLayout] = useState('none');
  const [description, setDescription] = useState({'en': ''});
  const [imageUrl, setImageUrl] = useState({'en': ''});
  const [imageUrlMobile, setImageUrlMobile] = useState({'en': ''});
  const [link, setLink] = useState();
  //const [isPublic, setIsPublic] = useState(false);

  // const [showModal, setShowModal] = useState(false);
  const [activeLang, setActiveLanguage] = useState('');
  const [imageObj, setimageObj] = useState({});

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);

      if (component) {
        const {
          isDisplayDescriptionOn: currentIsDisplayDescriptionOn,
          description: currentDescription,
          imageUrl: currentImageUrl,
          imageUrlMobile: currentImageUrlMobile,
          layout: currentLayout,
          link: currentLink,
          //isPublic: currentIsPublic = true,
        } = component;

        setState(component);
        setShowDescription(currentIsDisplayDescriptionOn);
        setDescription(currentDescription);
        setLayout(currentLayout);
        setImageUrl(currentImageUrl);
        setImageUrlMobile(currentImageUrlMobile);
        setLink(currentLink);
        //setIsPublic(currentIsPublic);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);


  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);

    const construction = {
      type: state.type,
      compId: state.compId || '',
      isDisplayDescriptionOn: showDescription,
      description: {...description},
      imageUrl: {...imageUrl},
      imageUrlMobile: { ...imageUrlMobile },
      link,
      layout,
      //isPublic,
    }

    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    showDescription,
    description,
    layout,
    imageUrl,
    link,
  ]);



  // const handleshowDescription = () => {
  //   setshowDescription(!showDescription);

  //   const { component } = components[index];

  //   const comp = {
  //     ...component,
  //     isDisplayDescriptionOn: showDescription,
  //   };

  //   setState(comp);

  //   const componentObj = {
  //     id,
  //     component: comp,
  //   };

  //   handlerSetComponents(componentObj, index);
  // };

  // useEffect(() => {
  //   handleshowDescription(false);
  // }, [imageObj]);

  const titleChange = (e) => {
    description[activeLanguage] = e.target.value
    setDescription({ ...description });
  };

  const linkChange = (e) => {
    const { value } = e.target;
    setLink(value);
  };

  return (
    <>
      <div className="flex">
        <div className="flex-1 pr-2">
          <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
            Mobile Image
          </label>
          <UIImage
            imageUrl={imageUrlMobile}
            setImageUrl={setImageUrlMobile}
            activeLanguage={activeLanguage}
            description={description}
            setDescription={setDescription}
          />
        </div>
        <div className="flex-1 pl-2">
          <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
            Desktop Image
          </label>
          <UIImage
            imageUrl={imageUrl}
            setImageUrl={setImageUrl}
            activeLanguage={activeLanguage}
            description={description}
            setDescription={setDescription}
          />
        </div>
      </div>
      <div className="flex flex-wrap text-black">
        <div className="flex-1 mr-4">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Link (if internal just use: /artista/interpol)
          </label>
          <input
            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            type="text"
            onChange={linkChange}
            value={link || ''}
          />
        </div>
        <div className="">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Layout
                  </label>
            <div className="relative">
              <select
                className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
                value={layout}
                onChange={e => setLayout(e.target.value)}
              >
                <option value={'none'}>Default</option>
                <option value={'head'}>Head</option>
                <option value={'head_alternative'}>Head Alternative</option>
                <option value={'width_text'}>Width Text</option>
                <option value={'over_text'}>Over Text</option>

              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  /></svg>
              </div>
            </div>
          </div>
      </div>
      <div className="flex-1 text-black">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Footnote
          </label>
          <textarea
            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            onChange={titleChange}
            value={description[activeLanguage] || ''}
          >
            {description[activeLanguage] || ''}
          </textarea>
        </div>
      {/* Toggle */}
        <div className="flex w-full my-6 items-center text-black">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Show footnote?</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            value={showDescription}
            onChange={() => setShowDescription(!showDescription)}
            checked={showDescription}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
        </div>
    </div>

    </>
  );

  return (
    <>
      {languages.map(lang => (
        <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block bg-greyFilter rounded-lg flex flex-row justify-between items-center' : 'hidden'}`}>
          <div className="pl-16 pt-1">
            {/* <div className="font-americaMonoRegular text-xs uppercase mt-1 w-full text-white" htmlFor="imageDescription">
              <PageTypeCheckbox checked={state.isDisplayDescriptionOn === true} value="checkedA" onClick={handleshowDescription} />
              <span className="font-americaMonoRegular text-xs uppercase text-black">Show Description</span>
            </div> */}
            {/* {state.isDisplayDescriptionOn && <div className="font-americaMonoRegular text-xs my-1 ml-2">{state.description[activeLanguage]}</div>} */}
            {/* {state.imageUrl && (
              <div className="font-americaMonoRegular text-xs uppercase mt-4 w-full text-white" htmlFor="imageUrl" onClick={() => toggleModal(activeLanguage)}>
                Image URL
                <input className="font-americaMonoRegular p-2 bg-white outline-none mt-2 rounded-full w-full" name="imageUrl" lang={lang} type="text" value={state.imageUrl && state.imageUrl[activeLanguage.toLowerCase()]} readOnly={reusableComponent && reusableComponent} disabled />
              </div>
            )} */}
            <div className="image pl-8 pb-1">{state.imageUrl[activeLanguage] && <img src={imageModifier(state.imageUrl[activeLanguage], '120x120')} alt={state.description.en} className="rounded" />}</div>
          </div>

          <div className="bg-greyFilter pb-2 pt-1 pl-16 rounded-r-lg pr-4 mt-1">
            <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-black text-white flex flex-row items-center" type="button" onClick={() => toggleModal(activeLanguage)}>
              {state && state.hasOwnProperty('imageUrl') && state.imageUrl[activeLanguage] ? 'Change image' : 'Select image'}
              {state && state.hasOwnProperty('imageUrl') && state.imageUrl[activeLanguage] ? <span className="font-icon icon-loading-arrows text-sm pl-2 text-white" /> : <span className="font-icon icon-add-button text-base text-white font-bold pl-2" />}
            </button>
          </div>
        </div>
      ))}

    </>
  );
};

ImageModule.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
};
ImageModule.defaultProps = {
  reusableComponent: null,
};

export default ImageModule;
